import React, { useState, useEffect } from "react";
import { MultiSelect } from 'primereact/multiselect';
import { setPeriods } from 'src/redux/actions';
import { useDispatch, useSelector } from 'react-redux';

export default function Periods(props) {
  const [selectAll, setSelectAll] = useState(true);
  const dispatch = useDispatch();
  const periods = useSelector((state) => state.filter.periods) || [];
  const items = Array.from(Object.keys(props.remote_source), key => ({
    label: props.remote_source[key],
    value: key,
  }));
  return (
    <div className="card flex justify-content-center" style={{border:'none'}}>
            <label className="control-label justify-content-start" htmlFor={props.id}>
            {props.label} 
          </label>
      <MultiSelect
        value={periods}
        options={items}
        onChange={(e) => dispatch(setPeriods(e.value))}

        filter
        maxSelectedLabels={1}
        placeholder={"Select " + props.label}
        className="w-full md:w-20rem"
      />
    </div>
  );
}
